var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from 'react';
import { Transition } from '@headlessui/react';
import clsx from 'clsx';
import { BackgroundProvider } from '../BackgroundContext/index.js';
import { XIcon } from '../icons/index.js';
import { ToastProvider, useToastContext } from './ToastContext.js';
import { ToastIcon } from './ToastIcon.js';
export const ToastComponent = (props) => {
    const { open, onClose, status = 'neutral', children, className } = props, rest = __rest(props, ["open", "onClose", "status", "children", "className"]);
    return (React.createElement(Transition, { show: open, as: Fragment, enter: "transform ease-out duration-300 transition", enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2", enterTo: "translate-y-0 opacity-100 sm:translate-x-0", leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0" },
        React.createElement("div", Object.assign({ className: clsx('max-w-sm w-full shadow-lg rounded-lg overflow-hidden pointer-events-auto border border-surface-200', 'bg-surface-50 text-basicSurface-500', 'focus-visible:ring-1 focus:outline-none', className) }, rest),
            React.createElement(ToastProvider, { onClose: onClose, status: status },
                React.createElement(BackgroundProvider, { backgroundType: "surface" }, children)))));
};
const ToastContent = props => {
    const { children, title, description, icon, withClose = true, className } = props, rest = __rest(props, ["children", "title", "description", "icon", "withClose", "className"]);
    const { status, onClose } = useToastContext();
    return (React.createElement("div", Object.assign({ className: clsx('p-4 relative', [
            status === 'neutral' && 'bg-surface-50',
            status === 'error' && 'bg-danger-50',
            status === 'warning' && ' bg-warning-50',
            status === 'success' && 'bg-success-50',
            status === 'info' && 'bg-info-50 ',
        ], className) }, rest),
        React.createElement("div", { className: "flex items-start text-sm " },
            React.createElement("div", { className: "flex-shrink-0" },
                React.createElement(ToastIcon, { status: status }, icon)),
            React.createElement("div", { className: clsx('ml-3 flex-1', withClose && 'mr-8') },
                title && (React.createElement("p", { className: clsx('font-medium', [
                        status === 'neutral' && 'text-basicSurface-900',
                        status === 'error' && 'text-danger-800',
                        status === 'warning' && 'text-warning-800',
                        status === 'success' && 'text-success-800',
                        status === 'info' && 'text-info-800',
                    ]) }, title)),
                description && (React.createElement("p", { className: clsx('mt-1', [
                        status === 'neutral' && 'text-basicSurface-500',
                        status === 'error' && 'text-danger-700',
                        status === 'warning' && 'text-warning-700',
                        status === 'success' && 'text-success-700',
                        status === 'info' && 'text-info-700',
                    ]) }, description)),
                children),
            withClose && (React.createElement("span", { className: "absolute top-0 right-0 flex items-center mr-4 mt-4" },
                React.createElement("button", { type: "button", className: clsx('rounded-md inline-flex focus:outline-none focus-visible:ring', [
                        status === 'neutral' && 'bg-surface-50',
                        status === 'error' && 'bg-danger-50',
                        status === 'warning' && ' bg-warning-50',
                        status === 'success' && 'bg-success-50',
                        status === 'info' && 'bg-info-50 ',
                    ]), onClick: onClose },
                    React.createElement("span", { className: "sr-only" }, "Close"),
                    React.createElement(XIcon, { className: clsx('h-5 w-5', [
                            status === 'neutral' &&
                                'text-basicSurface-400 hover:text-basicSurface-500',
                            status === 'error' && 'text-danger-400 hover:text-danger-500',
                            status === 'warning' &&
                                'text-warning-400 hover:text-warning-500',
                            status === 'success' &&
                                'text-success-400 hover:text-success-500',
                            status === 'info' && 'text-info-400 hover:text-info-500',
                        ]), "aria-hidden": "true" })))))));
};
ToastComponent.Content = ToastContent;
//# sourceMappingURL=ToastComponent.js.map